import(/* webpackMode: "eager" */ "/app/app/(providers)/neuro-spinal-surgery-detailpage/page.js");
